import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import UserContext from 'containers/user/userContext'
import OrganizationsContext from 'containers/organizations/organizationsContext'
import ChangePasswordTab from 'components/SettingsTabs/ChangePasswordTab'

const SecurityTab = () => {
  const user = useContext(UserContext)
  const { currentOrganization } = useContext(OrganizationsContext)
  const history = useHistory()

  // Check if user has password signin enabled
  // TODO: Get actual value from user object when available
  const hasPasswordSignin = true // user?.is_password_signin || false

  const navigateToDevices = () => {
    history.push(
      `/organization/${currentOrganization.slug}/account-settings/devices-sessions`
    )
  }

  return (
    <div style={{ marginTop: '1rem', width: '100%', maxWidth: '700px', padding: '0 1rem', boxSizing: 'border-box' }}>
      {hasPasswordSignin ? (
        <div>
          <h3 style={{ marginBottom: '1rem' }}>Password</h3>
          <ChangePasswordTab />
        </div>
      ) : (
        <div
          style={{
            padding: '2rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            textAlign: 'center',
            }}
        >
          <span
            className="material-icons-outlined"
            style={{ fontSize: '3rem', color: '#6c757d' }}
          >
            lock
          </span>
          <h4 style={{ marginTop: '1rem', wordBreak: 'break-word' }}>Password Login Not Available</h4>
          <p style={{ color: '#6c757d', lineHeight: '1.6', wordBreak: 'break-word' }}>
            You signed up using a third-party provider (Google or Microsoft). To enable
            password login, please add it from the Login Providers tab.
          </p>
        </div>
      )}

      <div style={{ marginTop: '3rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>Two-Factor Authentication</h3>
        <div
          style={{
            padding: '1.5rem',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            backgroundColor: '#fff',
            position: 'relative',
          }}
          >
          <div
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              padding: '0.25rem 0.75rem',
              backgroundColor: '#6c757d',
              color: 'white',
              borderRadius: '12px',
              fontSize: '0.75rem',
              fontWeight: 600,
            }}
          >
            COMING SOON
          </div>
          <div className="box-container" style={{ display: 'flex', alignItems: 'start', gap: '1rem' }}>
            <span
              className="material-icons-outlined"
              style={{ fontSize: '2.5rem', color: '#495057' }}
            >
              security
            </span>
            <div>
              <h4 style={{ margin: '0 0 0.5rem 0', wordBreak: 'break-word' }}>
                Enhanced Security with 2FA
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#6c757d', lineHeight: '1.6', wordBreak: 'break-word' }}>
                Two-factor authentication adds an extra layer of security to your account.
                When enabled, you'll need to provide both your password and a verification
                code from your phone to sign in.
              </p>
              <button
                type="button"
                className="submit-button"
                style={{
                  marginTop: '1rem',
                  padding: '0.5rem 1.5rem',
                  fontSize: '0.9rem',
                  minWidth: '120px',
                  opacity: 0.6,
                  cursor: 'not-allowed',
                }}
                disabled
              >
                Enable 2FA
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '3rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>Active Devices & Sessions</h3>
        <div
          style={{
            padding: '1.5rem',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            backgroundColor: '#fff',
          }}
        >
          <div className="box-container" style={{ display: 'flex', alignItems: 'start', gap: '1rem' }}>
            <span
              className="material-icons-outlined"
              style={{ fontSize: '2.5rem', color: '#495057' }}
            >
              devices
            </span>
            <div style={{ flex: 1 }}>
              <h4 style={{ margin: '0 0 0.5rem 0', wordBreak: 'break-word' }}>
                Manage Your Devices
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#6c757d', lineHeight: '1.6', wordBreak: 'break-word' }}>
                View and manage all devices that have accessed your account. You can revoke
                access to any device or delete devices you no longer use.
              </p>
              <button
                type="button"
                className="submit-button"
                style={{
                  marginTop: '1rem',
                  padding: '0.5rem 1.5rem',
                  fontSize: '0.9rem',
                  minWidth: '120px',
                }}
                onClick={navigateToDevices}
              >
                View Devices
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: '2rem',
          padding: '1rem',
          backgroundColor: '#d1ecf1',
          border: '1px solid #bee5eb',
          borderRadius: '4px',
        }}
      >
        <div  style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span className="material-icons-outlined" style={{ color: '#0c5460' }}>
            lightbulb
          </span>
          <strong style={{ color: '#0c5460' }}>Security Best Practices</strong>
        </div>
        <ul
          style={{
            margin: '0.5rem 0 0 1.5rem',
            color: '#0c5460',
            fontSize: '0.9rem',
            lineHeight: '1.8',
          }}
        >
          <li>Use a strong, unique password for your account</li>
          <li>Enable two-factor authentication when available</li>
          <li>Review your active devices regularly</li>
          <li>Never share your login credentials with anyone</li>
          <li>Log out of shared or public computers</li>
        </ul>
      </div>
    </div>
  )
}

export default SecurityTab
